/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExhibitorDto } from '../../models/exhibitor-dto';
import { UpdateExhibitorDto } from '../../models/update-exhibitor-dto';

export interface ExhibitorControllerUpdateV1$Params {
  id: string;
      body: UpdateExhibitorDto
}

export function exhibitorControllerUpdateV1(http: HttpClient, rootUrl: string, params: ExhibitorControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ExhibitorDto>> {
  const rb = new RequestBuilder(rootUrl, exhibitorControllerUpdateV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExhibitorDto>;
    })
  );
}

exhibitorControllerUpdateV1.PATH = '/api/v1/exhibitor/{id}';
